import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import moment from 'moment';
import { getPublicRsvpPage, resetGuestRsvp } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import GuestLookupForm from './rsvpV2/GuestLookupForm';
import GuestRsvpForm from './rsvpV2/GuestRsvpForm';
// import Address from '../../common/ui/Address';


// function RsvpPageHeader({ page, guestGroupRsvp, wedding }) {
//   let numEvents = 0;
//   let numEventsRequiringRsvp = 0;
//   if (guestGroupRsvp.events) {
//     numEvents = guestGroupRsvp.events.length;
//     numEventsRequiringRsvp = guestGroupRsvp.events.filter(event => event.collect_rsvps === true).length;
//   }
//   return (
//     <div className={`cms-page-header${(!page.description && !page.header_image_url) || !page.title ? ' flex-container' : ''}`}>
//       <div className="cms-header-accent-top-left" />
//       <div className="cms-header-accent-top-right" />
//       <div className="cms-header-accent-bottom-left" />
//       <div className="cms-header-accent-bottom-right" />
//       <h1 className="for-small-laptops">{page.title}</h1>
//       {page.header_image_url && (
//         <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
//       )}
//       {page.description && (
//         <p className={`page-description${page.header_image_url ? ' has-image-above' : ''}`}>{page.description}</p>
//       )}
//       <div className="hidden-xs">
//         {numEvents > 0 && !guestGroupRsvp.success && (
//           <p>
//             {wedding.owner_first_name} and {wedding.partner_first_name} have invited you to {numEvents} wedding events, {numEventsRequiringRsvp} of which {numEventsRequiringRsvp === 1 ? 'requires' : 'require'} your RSVP.<br />Be sure to scroll all the way down.
//           </p>
//         )}
//         {numEvents > 0 && guestGroupRsvp.success && (
//           <p>
//             Thank you for your RSVP!
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }
//
// RsvpPageHeader.propTypes = {
//   page: PropTypes.shape({}),
//   guestGroupRsvp: PropTypes.shape({}),
//   wedding: PropTypes.shape({}),
// };


class Rsvp extends Component {
  componentDidMount() {
    const { getRsvpEntities, forPreview } = this.props;
    if (!forPreview) {
      getRsvpEntities();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, resetGuestGroup, forPreview } = this.props; // eslint-disable-line
    if (!forPreview) {
      // consider removing one or both of these so that rsvp state is not lost when navigating away -
      // need to make sure doesn't have any unforeseen side effects
      unloadEntities();
      // resetGuestGroup();
    }
  }

  render() {
    const { page, forPreview, guestGroupRsvp, busy } = this.props;
    return (
      <div id="rsvp-page-v2" className="container">
        {page && !busy && (
          <div>
            {!forPreview && !guestGroupRsvp.guest_group_id && !guestGroupRsvp.success && (
              <GuestLookupForm />
            )}
            {(forPreview || guestGroupRsvp.guest_group_id) && (
              <GuestRsvpForm forPreview={forPreview} page={page} />
            )}
          </div>
        )}
      </div>
    );
  }
}

Rsvp.propTypes = {
  getRsvpEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  resetGuestGroup: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({}).isRequired,
  guestGroupRsvp: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  busy: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  wedding: ownProps.forPreview ? state.wedding.wedding : state.publicWebsite.wedding,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  guestGroupRsvp: ownProps.forPreview ? {} : state.publicWebsite.guestGroupRsvp,
  busy: state.publicWebsite.busy
});

const mapDispatchToProps = dispatch => ({
  getRsvpEntities: () => dispatch(getPublicRsvpPage()),
  unloadEntities: () => dispatch(resetEntities()),
  resetGuestGroup: () => dispatch(resetGuestRsvp())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Rsvp);



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/RsvpV2.jsx
 **/